export default __webpack_public_path__ + "static/media/bike.61d53367.svg";